// pages/Dashboard.jsx
import BooksByAuthor from "../../components/home/BooksByAuthorP";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BooksByAuthor />
    </HomeLayout>
  );
}
